import React, { useEffect, useState } from 'react';
import Breadcrumbs from '../../common/Breadcrumbs';
import RecentPost from './RecentPost';
import Blog1 from "../../../assets/images/blog-1.jpg";
import Blog2 from "../../../assets/images/blog-2.jpg";
import Blog3 from "../../../assets/images/blog-3.jpg";
import { useNavigate, useParams } from 'react-router-dom';
import { revertSlug } from '../../../utils/slugGenerator';
import { axiosInstance, config } from '../config';
import moment from 'moment';
import { notification } from 'antd';
import Loader from '../../common/Loader';

const NewsDetails = () => {
    const { slug } = useParams();
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: '',
    });
    const [errors, setErrors] = useState({});

    const Navigate = useNavigate()

    const [data, setdata] = useState([])
    const [latest,setLatest] = useState([]);
    const [Loading , setLoading] = useState(false);
    const [Tags , setTags] = useState([]);

    useEffect(() => {
        setLoading(true)
        axiosInstance.get(`news/${slug}`)
            .then(res => {
                setdata(res?.data?.News_Update)
                setLatest(res?.data?.latest)
                setTags(JSON.parse(res?.data?.News_Update?.tags))
                setLoading(false);
            })
            .catch((err) => {
                console.log(err)
                Navigate(`${config.appUrl}news-and-update`);
            })
            .finally(() => {
                setLoading(false)
            })
    },[slug])

    const handlesubmit = async(e) => {
        e.preventDefault();

        // Validate form data
        const newErrors = {};
        if (!formData.name) newErrors.name = "Name is required";
        if (!formData.email) {
            newErrors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = "Email is invalid";
        }
        if (!formData.message) newErrors.message = "Comment is required";

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return; // Stop submission if there are errors
        }

        try{

            setLoading(true);

            const Comment = new FormData();
            Comment.append("newsid" , data?.id);
            Comment.append("name" , formData.name);
            Comment.append("email" , formData.email);
            Comment.append("comment" , formData.message);

            const response = await axiosInstance.post(`news/comment` , Comment)

            if(response?.data?.success){
                setLoading(false);
                notification.open({
                    message: (
                        <div className="d-flex">
                            <div className="pr-20">
                                <i
                                    className="bi bi-check2-circle text-success"
                                    style={{ fontSize: "20px" }}
                                ></i>
                            </div>
                            <div>Comment Submitted Sucessfully</div>
                        </div>
                    ),
                });
            }else{
                setLoading(false);
                notification.open({
                    message: (
                      <div className="d-flex">
                        <div className="pr-20">
                          <i
                            className="bi bi-exclamation-circle-fill text-danger"
                            style={{ fontSize: "20px" }}
                          ></i>
                        </div>
                        <div>Opps! Something went wrong.</div>
                      </div>
                    ),
                    description: "Try Again !",
                });
            }

        }catch(e){
            console.log("Error" , e);
        }
        setFormData({ name: '', email: '', message: '' });
        setErrors({});
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
        // Clear error for the field being edited
        setErrors({
            ...errors,
            [name]: ''
        });
    };

    useEffect(() => {
        // Select all tables inside div elements
        const tables = document.querySelectorAll('.desc table');
        if (tables) {
            // Loop through each table and wrap it inside a new div with the 'table-responsive' class
            tables.forEach(table => {
                // Create a new div element
                const wrapperDiv = document.createElement('div');
                wrapperDiv.classList.add('table-responsive');
    
                // Insert the new div before the table
                table.parentNode.insertBefore(wrapperDiv, table);
    
                // Move the table inside the new div
                wrapperDiv.appendChild(table);
            });
        }
    }, [data])

    return (
        <div>
            {Loading && <Loader/>}
            <Breadcrumbs title={data?.title} date={moment(data?.created_at).format("MMMM D , YYYY")} added={'Admin'} category={data?.category} comment={data?.comments?.length} blogs={true} />

            <div className="rs-inner-blog pt-120 pb-120 md-pt-80 md-pb-80">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 pr-35 md-pr-15 md-mb-50">
                            <div className="widget-area mb-4">
                                <div className="tags-cloud d-block d-xl-none">
                                    <div className="widget-title pb-23">
                                        <h3 className="title">Tags</h3>
                                    </div>
                                    <div className="tagcloud">
                                        {Tags.length > 0 && Tags?.map((item) => (
                                            <a href="#">{item}</a>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="blog-details">
                                <div className="blog-full">
                                    <div className="bs-img">
                                        <img src={data?.imageUrl} alt="Blog" className='w-100 object-fit-cover' />
                                    </div>
                                    <div className="blog-content-full">
                                        <p className="desc marign-0 pt-34" dangerouslySetInnerHTML={{__html : data?.description}}>
                                        </p>
                                        
                                        <h3 className="title title2 pt-25 pb-22">Leave a Reply</h3>
                                        <p className="margin-0 pb-24">Your email address will not be published. Required fields are marked *</p>
                                        <div className="comment-note">
                                            <div id="form-messages"></div>
                                            <form id="contact-form" onSubmit={handlesubmit}>
                                                <fieldset>
                                                    <div className="row">
                                                        <div className="col-lg-6 mb-35 col-md-6 col-sm-6">
                                                            <input 
                                                                className={`from-control ${errors.name ? 'is-invalid' : ''}`} 
                                                                type="text" 
                                                                id="name" 
                                                                name="name" 
                                                                placeholder="Name*" 
                                                                value={formData.name} 
                                                                onChange={handleChange} 
                                                                // required 
                                                            />
                                                            {errors.name && <div className="invalid-feedback ps-2">* {errors.name}</div>}
                                                        </div>
                                                        <div className="col-lg-6 mb-35 col-md-6 col-sm-6">
                                                            <input 
                                                                className={`from-control ${errors.email ? 'is-invalid' : ''}`} 
                                                                type="text" 
                                                                id="email" 
                                                                name="email" 
                                                                placeholder="E-Mail*" 
                                                                value={formData.email} 
                                                                onChange={handleChange} 
                                                                // required 
                                                            />
                                                            {errors.email && <div className="invalid-feedback ps-2">* {errors.email}</div>}
                                                        </div>
                                                        <div className="col-lg-12 mb-30">
                                                            <textarea 
                                                                className={`from-control ${errors.message ? 'is-invalid' : ''}`} 
                                                                id="message" 
                                                                name="message" 
                                                                placeholder="Comment*" 
                                                                value={formData.message} 
                                                                onChange={handleChange} 
                                                                // required 
                                                            ></textarea>
                                                            {errors.message && <div className="invalid-feedback ps-2">* {errors.message}</div>}
                                                        </div>
                                                    </div>
                                                    <div className="btn-part">
                                                        <div className="form-group mb-0">
                                                            <p className="submit-btn submit-btn2 details">
                                                                <span className="arrow-btn">
                                                                    <input type="submit" value="Post Comment" />
                                                                </span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </fieldset>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12 pl-20 md-pl-15">
                            <div className="widget-area">
                                <RecentPost recentNews={latest} />
                                <div className="tags-cloud d-none d-xl-block">
                                    <div className="widget-title pb-23">
                                        <h3 className="title">Tags</h3>
                                    </div>
                                    <div className="tagcloud">
                                        {Tags.length > 0 && Tags?.map((item) => (
                                            <a href="#">{item}</a>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewsDetails;
